import { render, staticRenderFns } from "./OurHistory.vue?vue&type=template&id=303ec382&scoped=true"
import script from "./OurHistory.js?vue&type=script&lang=js&external"
export * from "./OurHistory.js?vue&type=script&lang=js&external"
import style0 from "./OurHistory.scss?vue&type=style&index=0&id=303ec382&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303ec382",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default})
